module.exports = __webpack_public_path__ + "img/02.4958f18a.jpg";